import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatementsComponent implements OnInit, AfterViewInit, OnDestroy {
  UseRTFToggleOne: any;
  UseRTFToggleTwo: any;
  UseRTFToggleThree: any;
  UseRTFFileOneName: any;
  UseRTFFileTwoName: any;
  UseRTFFileThreeName: any;
  filenames: any = [];
  isspiner: boolean = false;
  isspinerIS: boolean = false;
  isspinerFooter: boolean = false;
  isspinerCost: boolean = false;
  confirmDialogRef: MatDialogRef<any>;
  @Input() SettingForm: FormGroup;
  isLoadingResults: boolean = false;
  @Input() errorWarningData: any;
  private _unsubscribeAll$: Subject<void> = new Subject();
  constructor(
    private behaviorService: BehaviorService,
    public _matDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private toastr: ToastrService,
    private _mainAPiServiceService: MainAPiServiceService,
    private cd: ChangeDetectorRef,
  ) {}
  ngAfterViewInit(): void {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingSystemSetting('statements');
    this.loadData();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * load the data of statements
   */
  loadData() {
    // this.isLoadingResults = true;
    this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: { GroupName: 'Statements' } }, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            // this.isLoadingResults = false;
            let tempData: any = response.DATA.RECORDS;
            this.SettingForm.patchValue({
              STATEMENT2: tempData.STATEMENT2,
              STATEMENT3: tempData.STATEMENT3,
              STATEMENT4: tempData.STATEMENT4,
              STATEMENT5: tempData.STATEMENT5,
              STATEMENT2RTFBASE64: tempData.STATEMENT2RTFBASE64,
              STATEMENT3RTFBASE64: tempData.STATEMENT3RTFBASE64,
              STATEMENT4RTFBASE64: tempData.STATEMENT4RTFBASE64,
              STATEMENT2RTFFILE: tempData.STATEMENT2RTFFILE,
              STATEMENT3RTFFILE: tempData.STATEMENT3RTFFILE,
              STATEMENT4RTFFILE: tempData.STATEMENT4RTFFILE,
              STATEMENT2ISRTF: tempData.STATEMENT2ISRTF,
              STATEMENT3ISRTF: tempData.STATEMENT3ISRTF,
              STATEMENT4ISRTF: tempData.STATEMENT4ISRTF,
              FEEAGREEMENTSTATEMENT: tempData.FEEAGREEMENTSTATEMENT,
            });
            this.cd.markForCheck();
          }
        },
        error: (error: any) => {
          this.toastr.error(error);
        },
      });
  }

  /**
   * This function is used to save the statement
   */
  saveStatements() {
    this.isspiner = true;

    let data: any = {
      GroupName: 'Statements',
      STATEMENT2: this.SettingForm.controls['STATEMENT2'].value
        ? this.SettingForm.controls['STATEMENT2'].value
        : '',
      STATEMENT3: this.SettingForm.controls['STATEMENT3'].value
        ? this.SettingForm.controls['STATEMENT3'].value
        : '',
      STATEMENT4: this.SettingForm.controls['STATEMENT4'].value
        ? this.SettingForm.controls['STATEMENT4'].value
        : '',
      STATEMENT2ISRTF: this.SettingForm.controls['STATEMENT2ISRTF'].value
        ? this.SettingForm.controls['STATEMENT2ISRTF'].value
        : '',
      STATEMENT2RTFFILE: this.SettingForm.controls['STATEMENT2RTFFILE'].value
        ? this.SettingForm.controls['STATEMENT2RTFFILE'].value
        : '',
      STATEMENT2RTFBASE64: this.SettingForm.controls['STATEMENT2RTFBASE64'].value
        ? this.SettingForm.controls['STATEMENT2RTFBASE64'].value
        : '',
      STATEMENT3ISRTF: this.SettingForm.controls['STATEMENT3ISRTF'].value
        ? this.SettingForm.controls['STATEMENT3ISRTF'].value
        : '',
      STATEMENT3RTFFILE: this.SettingForm.controls['STATEMENT3RTFFILE'].value
        ? this.SettingForm.controls['STATEMENT3RTFFILE'].value
        : '',
      STATEMENT3RTFBASE64: this.SettingForm.controls['STATEMENT3RTFBASE64'].value
        ? this.SettingForm.controls['STATEMENT3RTFBASE64'].value
        : '',
      STATEMENT4ISRTF: this.SettingForm.controls['STATEMENT4ISRTF'].value
        ? this.SettingForm.controls['STATEMENT4ISRTF'].value
        : '',
      STATEMENT4RTFFILE: this.SettingForm.controls['STATEMENT4RTFFILE'].value
        ? this.SettingForm.controls['STATEMENT4RTFFILE'].value
        : '',
      STATEMENT4RTFBASE64: this.SettingForm.controls['STATEMENT4RTFBASE64'].value
        ? this.SettingForm.controls['STATEMENT4RTFBASE64'].value
        : '',
      STATEMENT5: this.SettingForm.controls['STATEMENT5'].value
        ? this.SettingForm.controls['STATEMENT5'].value
        : '',
      FEEAGREEMENTSTATEMENT: this.SettingForm.controls['FEEAGREEMENTSTATEMENT'].value
        ? this.SettingForm.controls['FEEAGREEMENTSTATEMENT'].value
        : '',
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save invoice statements tab only
   */
  saveInvoiceStatements() {
    this.isspinerIS = true;

    let data: any = {
      GroupName: 'Statements',
      SubgroupName: 'Invoice',
      STATEMENT2: this.SettingForm.controls['STATEMENT2'].value
        ? this.SettingForm.controls['STATEMENT2'].value
        : '',
      STATEMENT3: this.SettingForm.controls['STATEMENT3'].value
        ? this.SettingForm.controls['STATEMENT3'].value
        : '',
      STATEMENT4: this.SettingForm.controls['STATEMENT4'].value
        ? this.SettingForm.controls['STATEMENT4'].value
        : '',
      STATEMENT2ISRTF: this.SettingForm.controls['STATEMENT2ISRTF'].value
        ? this.SettingForm.controls['STATEMENT2ISRTF'].value
        : '',
      STATEMENT2RTFFILE: this.SettingForm.controls['STATEMENT2RTFFILE'].value
        ? this.SettingForm.controls['STATEMENT2RTFFILE'].value
        : '',
      STATEMENT2RTFBASE64: this.SettingForm.controls['STATEMENT2RTFBASE64'].value
        ? this.SettingForm.controls['STATEMENT2RTFBASE64'].value
        : '',
      STATEMENT3ISRTF: this.SettingForm.controls['STATEMENT3ISRTF'].value
        ? this.SettingForm.controls['STATEMENT3ISRTF'].value
        : '',
      STATEMENT3RTFFILE: this.SettingForm.controls['STATEMENT3RTFFILE'].value
        ? this.SettingForm.controls['STATEMENT3RTFFILE'].value
        : '',
      STATEMENT3RTFBASE64: this.SettingForm.controls['STATEMENT3RTFBASE64'].value
        ? this.SettingForm.controls['STATEMENT3RTFBASE64'].value
        : '',
      STATEMENT4ISRTF: this.SettingForm.controls['STATEMENT4ISRTF'].value
        ? this.SettingForm.controls['STATEMENT4ISRTF'].value
        : '',
      STATEMENT4RTFFILE: this.SettingForm.controls['STATEMENT4RTFFILE'].value
        ? this.SettingForm.controls['STATEMENT4RTFFILE'].value
        : '',
      STATEMENT4RTFBASE64: this.SettingForm.controls['STATEMENT4RTFBASE64'].value
        ? this.SettingForm.controls['STATEMENT4RTFBASE64'].value
        : '',
      STATEMENT5: this.SettingForm.controls['STATEMENT5'].value
        ? this.SettingForm.controls['STATEMENT5'].value
        : '',
      FEEAGREEMENTSTATEMENT: this.SettingForm.controls['FEEAGREEMENTSTATEMENT'].value
        ? this.SettingForm.controls['FEEAGREEMENTSTATEMENT'].value
        : '',
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerIS = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerIS = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerIS = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerIS = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerIS = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save global footer tab only
   */
  saveGlobalFooter() {
    this.isspinerFooter = true;
    let data: any = {
      GroupName: 'Statements',
      SubgroupName: 'GlobalFooter',
      STATEMENT5: this.SettingForm.controls['STATEMENT5'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerFooter = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerFooter = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerFooter = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerFooter = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerFooter = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save cost agreement tab only
   */
  saveCostAgreement() {
    this.isspinerCost = true;
    let data: any = {
      GroupName: 'Statements',
      SubgroupName: 'CostsAgreement',
      FEEAGREEMENTSTATEMENT: this.SettingForm.controls['FEEAGREEMENTSTATEMENT'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerCost = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerCost = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerCost = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerCost = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerCost = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * THis function is used to toggle the user RTFT1
   */
  UseRTFToggle1(event: any) {
    this.SettingForm.controls['STATEMENT2ISRTF'].setValue(event.checked);
    this.cd.markForCheck();
  }

  /**
   * THis function is used to toggle the user RTFT2
   */
  UseRTFToggle2(event: any) {
    this.SettingForm.controls['STATEMENT3ISRTF'].setValue(event.checked);
    this.cd.markForCheck();
  }

  /**
   * THis function is used to toggle the user RTFT3
   */
  UseRTFToggle3(event: any) {
    this.SettingForm.controls['STATEMENT4ISRTF'].setValue(event.checked);
    this.cd.markForCheck();
  }

  /**
   * this function is used to remove the confirm dialog data.
   */
  remove(imageType: any, id: any) {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage =
      'Are you sure you want to remove this Item?';
    this.confirmDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result: any) => {
        if (result) {
          switch (imageType) {
            case 'UseRTFToggleOne':
              this.SettingForm.controls['STATEMENT2RTFBASE64'].setValue('');
              this.SettingForm.controls['STATEMENT2RTFFILE'].setValue('');
              this.filenames = [];

              break;
            case 'UseRTFToggleTwo':
              this.UseRTFFileTwoName = '';
              this.SettingForm.controls['STATEMENT3RTFBASE64'].setValue('');
              this.SettingForm.controls['STATEMENT3RTFFILE'].setValue('');
              this.filenames = [];
              break;
            case 'UseRTFToggleThree':
              this.UseRTFFileThreeName = '';
              this.SettingForm.controls['STATEMENT4RTFBASE64'].setValue('');
              this.SettingForm.controls['STATEMENT4RTFFILE'].setValue('');
              this.filenames = [];
          }
          let data: any = document.getElementById(id);
          if (data) {
            data.value = '';
          }
          this.cd.markForCheck();
        }
      });
  }

  onFileChange(pFileList: File[], imageType: string) {
    switch (imageType) {
      case 'UseRTFToggleOne':
        this.SettingForm.controls['STATEMENT2RTFFILE'].setValue(
          pFileList['name'] ? pFileList['name'] : pFileList[0]['name'],
        );
        this.FileConvert64bit(pFileList, imageType);

        break;
      case 'UseRTFToggleTwo':
        this.SettingForm.controls['STATEMENT3RTFFILE'].setValue(
          pFileList['name'] ? pFileList['name'] : pFileList[0]['name'],
        );
        this.FileConvert64bit(pFileList, imageType);
        break;
      case 'UseRTFToggleThree':
        this.SettingForm.controls['STATEMENT4RTFFILE'].setValue(
          pFileList['name'] ? pFileList['name'] : pFileList[0]['name'],
        );
        this.FileConvert64bit(pFileList, imageType);
    }
    this.cd.markForCheck();
  }

  /**
   *
   */
  async FileConvert64bit(fileInput: any, type: any) {
    let PromiseData: any;
    let file64bit: any = [];
    this.filenames = [];
    let files: any = fileInput;
    // for (let i = 0; i < files.length; i++) {
    //     PromiseData =   await new Promise<void>(async (next, reject) => {
    //     await this.filenames.push(files.name ? files.name : files[i].name);
    //     var reader = await new FileReader();
    //     await reader.readAsDataURL(files[0] ? files[0] : files);
    //     reader.onload = await function () {
    //         file64bit = reader.result

    //        next();
    //     };
    //     reader.onerror = await function (error) {
    //       reject();
    //     }
    PromiseData = await new Promise<void>(async (next, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(files[0] ? files[0] : files);
      reader.onload = function () {
        file64bit.push(reader.result);
        next();
      };
      reader.onerror = function (error) {
        reject();
      };
    }).then();
    if (file64bit) {
      switch (type) {
        case 'UseRTFToggleOne':
          this.SettingForm.controls['STATEMENT2RTFBASE64'].setValue(file64bit[0]);
          break;
        case 'UseRTFToggleTwo':
          this.SettingForm.controls['STATEMENT3RTFBASE64'].setValue(file64bit[0]);
          break;
        case 'UseRTFToggleThree':
          this.SettingForm.controls['STATEMENT4RTFBASE64'].setValue(file64bit[0]);
      }
      this.cd.markForCheck();
    }
  }
}
